// 客户端使用svg按需引入
import Vue from 'vue'
import SvgIcon from './svg-icon'

Vue.component('SvgIcon', SvgIcon)

// 批量require所有的svg
const requireAll = requireContext => requireContext.keys().map(requireContext)
const req = require.context('./svg', false, /\.svg$/)
requireAll(req)
